import { useEffect, useState } from 'react';
import { GrantTypeOfferCombinationModel } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

const assignmentClient =
  moduleClientFactory.createCitizenAssignmentClient(true);

export function useGrantTypeOfferCombinations(companyId: string | undefined) {
  const [combinations, setCombinations] = useState<
    GrantTypeOfferCombinationModel[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!companyId) {
      setCombinations([]);
      return;
    }

    async function loadCombinations() {
      setIsLoading(true);
      try {
        const response =
          await assignmentClient.getGrantTypeOfferCombinationsForCompany({
            companyId: companyId!,
          });
        setCombinations(response.combinations ?? []);
      } finally {
        setIsLoading(false);
      }
    }
    loadCombinations();
  }, [companyId]);

  return { combinations, isLoading };
}
